import { useMemo } from "react";
import BaseModal from "./BaseModal";
import { FormattedMessage, useIntl } from "react-intl";
import { useEventStore, useTimeToReleaseUploadStore } from "store";
import recorderBlackIcon from "../assets/images/recorder-black-icon.png";
import recorderRedIcon from "../assets/images/recorder-red-icon.png";
import scheduleBlackIcon from "../assets/images/schedule-black-icon.png";
import scheduleRedIcon from "../assets/images/schedule-red-icon.png";
import { useNavigate } from "react-router-dom";

const BLACK_ICONS = {
  recorder: recorderBlackIcon,
  schedule: scheduleBlackIcon,
};

const RED_ICONS = {
  recorder: recorderRedIcon,
  schedule: scheduleRedIcon,
};

type TimeToShareModalProps = {
  setChooseTimeToShareModalOpen: (open: boolean) => void;
  chooseTimeToShareModalOpen: boolean;
};

interface OptionCardProps {
  icon: string;
  title: string;
  description: string;
  onClick: () => void;
}

const OptionCard = ({ icon, title, description, onClick }: OptionCardProps) => {
  const { theme } = useEventStore();

  return (
    <button
      type="button"
      className={`w-full flex items-center px-5 py-5 gap-2 ${
        theme.name === "rose" ? `card ${theme.card}` : `button ${theme.button}`
      } transition-transform duration-200 shadow-md hover:shadow-lg`}
      onClick={onClick}
    >
      <img src={icon} alt={title} className="w-20 transition-transform" />
      <div className="flex flex-col items-center gap-1 grow">
        <h3 className="text-lg font-semibold text-theme-black text-center">
          {title}
        </h3>
        <p className="text-theme-black text-sm w-48">{description}</p>
      </div>
    </button>
  );
};

export default function TimeToShareModal({
  setChooseTimeToShareModalOpen,
  chooseTimeToShareModalOpen,
}: TimeToShareModalProps) {
  const { theme } = useEventStore();
  const intl = useIntl();
  const navigate = useNavigate();
  const { setTimeToReleaseChoice } = useTimeToReleaseUploadStore();

  const menuIcons = useMemo(
    () => (theme.name === "rose" ? RED_ICONS : BLACK_ICONS),
    [theme]
  );

  return (
    <BaseModal
      onClose={() => setChooseTimeToShareModalOpen(false)}
      isOpen={chooseTimeToShareModalOpen}
    >
      <div className="py-2 gap-6 flex flex-col items-center h-full min-w-[80vw]">
        <h3 className="text-lg font-century-gothic-bold text-center">
          <FormattedMessage
            id="title.uploader.modalMixedEventTitle"
            defaultMessage="QUANDO você quer que os noivos recebam sua foto ou vídeo?"
          />
        </h3>
        <div className="flex flex-col items-center gap-4 grow flex-1 w-full">
          <OptionCard
            icon={menuIcons.recorder}
            title={intl.formatMessage({
              id: "button.options.sendNow",
              defaultMessage: "Enviar Agora",
            })}
            description={intl.formatMessage({
              id: "message.options.sendNow",
              defaultMessage:
                "Os noivos terão acesso aos arquivos imediatamente!",
            })}
            onClick={() => {
              setTimeToReleaseChoice("release-now");
              setChooseTimeToShareModalOpen(false);
              navigate("/record/form");
            }}
          />
          <OptionCard
            icon={menuIcons.schedule}
            title={intl.formatMessage({
              id: "button.options.sendLater",
              defaultMessage: "Nas Bodas de 1 Ano",
            })}
            description={intl.formatMessage({
              id: "message.options.sendLater",
              defaultMessage: "Enviar para a Cápsula do Tempo do evento!",
            })}
            onClick={() => {
              setTimeToReleaseChoice("release-later");
              setChooseTimeToShareModalOpen(false);
              navigate("/record/form");
            }}
          />
        </div>
      </div>
    </BaseModal>
  );
}
